import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import styles from "./index.module.css";
export const ErrorPopup = ({ text, onClose, duration = 5000 }) => {
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const timer = setTimeout(() => {
            setVisible(false);
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);
    if (!visible)
        return null;
    return (_jsx("div", { className: styles.errorMessage, children: text }));
};
